<template>
  <div class="navigator-centent as-flex flex-vertical main-start cross-center">
    <template v-for="(item, index) in pages">
      <div
        @click="goto(item.routeName)"
        :class="['routeItem', 'f-3', 'as-flex', 'main-start', 'cross-center', item.routeName===currentPage?'is-active':'is-not-active']"
        :key="index"
      >
        <div class="navi-img">
          <i :class="['icon', navi_img_mapping[item.routeName]]" alt></i>
        </div>
        <p>{{item.title}}</p>
      </div>
    </template>
  </div>
</template>

<script>
const navi_img_mapping = {
  index: "icon-navi-index",
  movieLib: "icon-navi-movielib",
  report: "icon-navi-report"
};
export default {
  name: "",
  props: {},
  data() {
    return {
      navi_img_mapping: navi_img_mapping,
      pages: [
        { title: "每周档期", iconSrc: "", routeName: "index" },
        { title: "影片库", iconSrc: "", routeName: "movieLib" },
        { title: "往期报告", iconSrc: "", routeName: "report" }
      ],
      currentPage: undefined
    };
  },
  computed: {},
  methods: {
    goto(data) {
      this.$router.push({ name: data });
    }
  },
  watch: {
    $route: function(to, from) {
      this.currentPage = to.name;
    }
  },
  created() {
    this.currentPage = this.$route.name || "index";
  }
};
</script>

<style lang="scss" scoped>
@keyframes toactive {
  from {
    box-shadow: none;
    background-color: #ffffff;
  }
  to {
    box-shadow: inset 6px 0 2px -2px #008cd6;
    background-color: #f9f9f9;
  }
}
@keyframes tonotactive {
  from {
    box-shadow: inset 6px 0 2px -2px #008cd6;
    background-color: #f9f9f9;
  }
  to {
    box-shadow: none;
    background-color: #ffffff;
  }
}
.navigator-centent {
  width: 100%;
}
.routeItem {
  width: 100%;
  height: 3em;
  padding: 0px 10px;
  color: #666666;
  &.is-active {
    animation: toactive 0.3s forwards;
  }
  &.is-not-active {
    animation: tonotactive 0.3s forwards;
    &:hover {
      color: #999999;
    }
  }
  .navi-img {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 0 10px;
  }
}
</style>
